import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

const EMPTY_LIST = [];

const selectLoanExceptionsRoot = state => state.loanExceptions;

const selectLoanExceptionsByLoan = createSelector(
  selectLoanExceptionsRoot,
  ({ loanExceptionsByLoan }) => loanExceptionsByLoan,
);

export const selectLoanExceptionsForLoan = memoizeOne(loanId =>
  createSelector(selectLoanExceptionsByLoan, byLoan => byLoan[loanId] || EMPTY_LIST),
);
